import httpRequest from "@/request/index";
import { signData, objectToSortedString} from "@/views/dgitalMan/utils";

export const ApiPerson = {
	// 上传文件
	upImg: (data : any) => {
		return httpRequest.request({
			url: `/api/zba/common/upload`,
			method: "post",
			data,
			headers: {
				"content-type": "multipart/form-data",
				"accept": "*/*",
				
			},
		});
	},
	// 背景图
	uploadBg: (params : any, data : any) => {
		return httpRequest.request({
			url: `/api/zba/digital/background/create?${params}`,
			method: "post",
			data,
		});
	},
	delBgImg: (params : any) => {
		return httpRequest.request({
			url: `/api/zba/digital/background/delete?${params}`,
			method: "get",
		});
	},
	getBgList: (params : any) => {
		return httpRequest.request({
			url: `/api/zba/digital/background/get?${params}`,
			method: "GET",
		});
	},
	// 数字人上传获取
	// 添加背景图
	addPerson: (params : any, data : any) => {
		return httpRequest.request({
			url: `/api/zba/digital/men/create?${params}`,
			method: "post",
			data,
		});
	},
	getPersonList: (params : any) => {
		return httpRequest.request({
			url: `/api/zba/digital/men/get?${params}`,
			method: "get",
		});
	},
	delPerson: (params : any) => {
		return httpRequest.request({
			url: `/api/zba/digital/men/delete?${params}`,
			method: "get",
		});
	},
	// 获取音色数据（系统预置）
	getAudioList: (params : any) => {
		return httpRequest.request({
			url: `/api/zba/digital/getTimbre?${params}`,
			method: "get",
		});
	},
	// 获取音色数据
	getPersonalAudioList: (params : any) => {
		return httpRequest.request({
			url: `/api/zba/digital/timbre/get?${params}`,
			method: "get",
		});
	},
	createPersonVideo: (params : any, data : any) => {
		return httpRequest.request({
			url: `/api/zba/digital/generate?${params}`,
			method: "post",
			data,
		});
	},
	getPersonVideo: (params : any) => {
		return httpRequest.request({
			url: `/api/zba/digital/getTask?${params}`,
			method: "get",
		});
	},
	getHistoryList: (params : any) => {
		return httpRequest.request({
			url: `/api/zba/myTask/getDigital/history?${params}`,
			method: "get",
		});
	},
	delHistoryList: (params : any) => {
		return httpRequest.request({
			url: `/api/zba/myTask/digital/delete?${params}`,
			method: "get",
		});
	},
	publishHistoryList: (params : any, data : any) => {
		return httpRequest.request({
			url: `/api/zba/aigcContent/publishDigital?${params}`,
			method: "post",
			data,
		});
	},
	clickPersonPublish: (params : any) => {
		return httpRequest.request({
			url: `/api/zba/data/statistics/dataInc?${params}`,
			method: "get",
		});
	},
	addVideoPlayImg: (params : any, data : any) => {
		return httpRequest.request({
			url: `/api/zba/digital/broadcast/pic/create?${params}`,
			method: "post",
			data,
		});
	},
	getVideoPlayImg: (params : any) => {
		return httpRequest.request({
			url: `/api/zba/digital/broadcast/pic/get?${params}`,
			method: "get",
		});
	},
	deleteVideoImg: (params : any) => {
		return httpRequest.request({
			url: `/api/zba/digital/broadcast/pic/delete?${params}`,
			method: "get",
		});
	},
	// 增加音色
	addPersonAudio: (params : any, data : any) => {
		return httpRequest.request({
			url: `/api/zba/digital/timbre/add?${params}`,
			method: "post",
			data
		});
	},
	// 删除音色
	deletePersonAudio: (params : any) => {
		return httpRequest.request({
			url: `/api/zba/digital/timbre/delete?${params}`,
			method: "get"
		});
	},
	// 内容翻译
	translateToEnglish: (params : any) => {
		return httpRequest.request({
			url: `/api/zba/aigc/content/translate?${params}`,
			method: "get"
		});
	},
	// 中文润色
	getChinesePromptPolish: (params : any, data : any) => {
		return httpRequest.request({
			url: `/api/zba/digital/getChinesePromptPolish?${params}`,
			method: "post",
			data
		});
	},
	// 解析文件
	parsingFile: (data : any) => {
		const sign = signData(data)
		return httpRequest.request({
			url: `/api/zba/zba/stepWriting/post/file?${sign}`,
			method: 'post',
			data
		});
	},
};